import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 44 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ index, label }) => (
  <div className="flex items-center gap-4 mb-8" data-testid={`section-tag-${label.toLowerCase().replace(/\s+/g, "-")}`}>
    <span className="font-mono2 text-xs text-[#2E7FE0] tracking-[0.25em]">{index}</span>
    <span className="h-px w-12 bg-[#2E7FE0]/50" />
    <span className="font-mono2 text-xs uppercase tracking-[0.35em] text-[#A1B0C8]">{label}</span>
  </div>
);

export const scrollToSection = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
